(() => {
  'use strict';

  const parserBridgeVersion = '3.7.1-bridge';
  const jQueryVersion = window.jQuery?.fn?.jquery;

  // Avoid replaying every legacy block against the small compatibility bridge
  // if the full jQuery request failed.
  if (!jQueryVersion || jQueryVersion === parserBridgeVersion) {
    console.error('Deferred jQuery scripts were not started because jQuery failed to load.');
    return;
  }

  // api.jquery can initialize against the parser bridge before the real
  // library executes. Restore its serializer to jQuery's implementation.
  if (
    window.__leonisaJQueryParserBridge &&
    window.Shopify &&
    window.jQuery?.param
  ) {
    window.Shopify.param = window.jQuery.param;
    delete window.__leonisaJQueryParserBridge;
  }

  const deferredType = 'text/x-jquery-deferred';
  const deferredSelector = `script[type="${deferredType}"]`;

  function executeScript(source) {
    if (!source.isConnected || source.type !== deferredType) return;

    const script = document.createElement('script');

    for (const attribute of source.attributes) {
      if (attribute.name !== 'type') {
        script.setAttribute(attribute.name, attribute.value);
      }
    }

    // Dynamically inserted external scripts are async by default. Preserve
    // document order unless the original tag explicitly opted into async.
    if (source.src && !source.hasAttribute('async')) {
      script.async = false;
    }

    script.text = source.textContent;
    source.replaceWith(script);
  }

  function executeScripts(root) {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;

    if (root.matches?.(deferredSelector)) {
      executeScript(root);
      return;
    }

    root.querySelectorAll?.(deferredSelector).forEach(executeScript);
  }

  // Shopify can replace sections without a full page load in the theme editor.
  const observer = new MutationObserver((mutations) => {
    for (const mutation of mutations) {
      mutation.addedNodes.forEach(executeScripts);
    }
  });

  observer.observe(document.documentElement, { childList: true, subtree: true });
  executeScripts(document);
})();
